"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var react_i18next_1 = require("react-i18next");
var react_router_dom_1 = require("react-router-dom");
var formik_1 = require("formik");
var settingsSlice_1 = require("../../../features/settings/settingsSlice");
var developerSlice_1 = require("../../../features/developers/developerSlice");
var userSlice_1 = require("../../../features/user/userSlice");
var objectHelper_1 = require("../../../helpers/objectHelper");
var settingsSchema_1 = __importDefault(require("../../../schemas/settingsSchema"));
var Routes_1 = require("../../../constants/Routes");
var globalSlice_1 = require("../../../features/global/globalSlice");
var ConfirmModal_1 = __importDefault(require("../../Modals/ConfirmModal"));
var DeveloperForm_1 = __importDefault(require("./SettingsForm/DeveloperForm"));
var PageLoader_1 = __importDefault(require("../../PageLoader"));
var PersonalForm_1 = __importDefault(require("./SettingsForm/PersonalForm"));
var lodash_1 = require("lodash");
var moment_1 = __importDefault(require("moment"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var Settings = function () {
    var _a;
    var _b = react_1.useState(false), confirmDeactivation = _b[0], setConfirmDeactivation = _b[1];
    var _c = react_1.useState(true), passwordResetCollapsed = _c[0], setPasswordResetCollapsed = _c[1];
    var history = react_router_dom_1.useHistory();
    var t = react_i18next_1.useTranslation('common').t;
    var dispatch = react_redux_1.useDispatch();
    var settings = react_redux_1.useSelector(settingsSlice_1.settingsSelector);
    var isLoading = react_redux_1.useSelector(settingsSlice_1.settingsLoadingSelector);
    var developers = react_redux_1.useSelector(developerSlice_1.selectDevelopers);
    var isDeveloper = react_redux_1.useSelector(userSlice_1.selectIsDeveloper);
    var developer = react_redux_1.useSelector(settingsSlice_1.selectDeveloper);
    var loading = react_redux_1.useSelector(userSlice_1.selectUserLoading);
    var settingsFormSchema = settingsSchema_1.default(passwordResetCollapsed, isDeveloper);
    react_1.useEffect(function () {
        window.scroll(0, 0);
        dispatch(settingsSlice_1.getProfile());
        dispatch(developerSlice_1.fetchDevelopers());
    }, []);
    var onImageChange = function (img, formikProps) {
        formikProps.setFieldValue('avatar', img);
    };
    var onAddEmpty = function (contacts, formikProps) {
        formikProps.setFieldValue('contacts', contacts);
    };
    var onChange = function (index, contact, formikProps) {
        formikProps.setFieldValue("contacts." + index, contact);
    };
    var onRemove = function (contacts, formikProps) {
        formikProps.setFieldValue('contacts', contacts);
    };
    var togglePasswordInputs = function (e, formikProps) {
        e.preventDefault();
        setPasswordResetCollapsed(function (collapsed) { return !collapsed; });
        formikProps.setFieldValue('oldPassword', '');
        formikProps.setFieldValue('password', '');
        formikProps.setFieldValue('passwordConfirmation', '');
    };
    var handleConfirm = function () {
        try {
            dispatch(settingsSlice_1.deactivate());
            setConfirmDeactivation(!confirmDeactivation);
            history.push(Routes_1.Routes.Home.path);
        }
        catch (e) {
            dispatch(globalSlice_1.addToastMessage({
                text: t('DEACTIVATION_FAILED'),
                appearance: 'error',
            }));
        }
    };
    var handleChangeAvatar = function (avatar) { return __awaiter(void 0, void 0, void 0, function () {
        var e_1, key;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, dispatch(settingsSlice_1.uploadAvatar(avatar))];
                case 1:
                    _a.sent();
                    dispatch(globalSlice_1.addToastMessage({
                        text: t('Account.Settings.AVATAR_SUCCESSFULLY_UPDATED'),
                        appearance: 'success',
                    }));
                    return [3 /*break*/, 3];
                case 2:
                    e_1 = _a.sent();
                    key = Object.keys(e_1.response.data.errors)[0];
                    dispatch(globalSlice_1.addToastMessage({
                        text: e_1.response.data.errors.avatar
                            ? t(e_1.response.data.errors.avatar)
                            : t('ERRORS.' + e_1.response.data.errors[key][0]),
                        appearance: 'error',
                    }));
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handleCancel = function () {
        setConfirmDeactivation(!confirmDeactivation);
    };
    var combineDeveloperData = function (developerData) {
        var dateOfEstablishment = developerData.dateOfEstablishment, restDeveloperData = __rest(developerData, ["dateOfEstablishment"]);
        if (dateOfEstablishment) {
            dateOfEstablishment = moment_1.default(dateOfEstablishment).format('YYYY-MM-DD');
        }
        restDeveloperData.projects = restDeveloperData.projects.filter(function (item) { return !!item.name; });
        return __assign(__assign({}, restDeveloperData), (dateOfEstablishment && { dateOfEstablishment: dateOfEstablishment }));
    };
    var handleSubmit = function (_a, action) { return __awaiter(void 0, void 0, void 0, function () {
        var e_2;
        var avatar = _a.avatar, rest = __rest(_a, ["avatar"]);
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 6, , 7]);
                    if (!isDeveloper) return [3 /*break*/, 2];
                    return [4 /*yield*/, dispatch(settingsSlice_1.updateProfile(combineDeveloperData(rest)))];
                case 1:
                    _b.sent();
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, dispatch(settingsSlice_1.updateProfile(rest))];
                case 3:
                    _b.sent();
                    _b.label = 4;
                case 4:
                    dispatch(globalSlice_1.addToastMessage({
                        text: t('PROFILE_SUCCESSFULLY_UPDATED'),
                        appearance: 'success',
                    }));
                    return [4 /*yield*/, dispatch(userSlice_1.getMyProfile())];
                case 5:
                    _b.sent();
                    return [3 /*break*/, 7];
                case 6:
                    e_2 = _b.sent();
                    if (e_2.response.data.errors['old_password']) {
                        action.setErrors({
                            oldPassword: t('YOUR_PASSWORD_IS_WRONG'),
                        });
                    }
                    dispatch(globalSlice_1.addToastMessage({
                        text: t('PROFILE_UPDATE_FAILED'),
                        appearance: 'error',
                    }));
                    return [3 /*break*/, 7];
                case 7: return [2 /*return*/];
            }
        });
    }); };
    var developerDefaults = {
        developerName: developer.name,
        website: developer.website || '',
        description: developer.description || '',
        dateOfEstablishment: developer.dateOfEstablishment || '',
        projects: ((_a = developer.developerProjects) === null || _a === void 0 ? void 0 : _a.length)
            ? developer.developerProjects
            : [
                {
                    id: lodash_1.uniqueId(),
                    name: '',
                },
            ],
        developerMedia: developer.developerMedia || [],
    };
    var initialValues = objectHelper_1.pickWithDefaults(settings, Object.assign({
        username: '',
        firstName: '',
        lastName: '',
        email: '',
        avatar: '',
        contacts: [
            {
                id: '',
                phone: '',
                code: 'am',
                messengers: [],
            },
        ],
    }, isDeveloper ? developerDefaults : {}));
    if (loading || isLoading) {
        return react_1.default.createElement(PageLoader_1.default, null);
    }
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("h1", null, t('Account.Settings.Settings')),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.settings },
            react_1.default.createElement(ConfirmModal_1.default, { open: confirmDeactivation, cancelButtonTitle: t('Account.Settings.DEACTIVATE_MODAL.NO'), confirmButtonTitle: t('Account.Settings.DEACTIVATE_MODAL.DEACTIVATE'), content: t('Account.Settings.DEACTIVATE_MODAL.TEXT'), headerTitle: t('Account.Settings.DEACTIVATE_MODAL.DEACTIVATE_ACCOUNT'), onCancel: handleCancel, onConfirm: handleConfirm }),
            react_1.default.createElement(formik_1.Formik, { initialValues: __assign(__assign({}, initialValues), { showPassword: false, oldPassword: '', password: '', passwordConfirmation: '' }), validationSchema: settingsFormSchema, onSubmit: handleSubmit, validateOnBlur: true }, function (formikProps) {
                return isDeveloper ? (react_1.default.createElement(DeveloperForm_1.default, __assign({}, formikProps, { onAddEmpty: onAddEmpty, onChange: onChange, onRemove: onRemove, togglePasswordInputs: togglePasswordInputs, onImageChange: onImageChange, passwordResetCollapsed: passwordResetCollapsed, developers: developers, isLoading: isLoading, handleChangeAvatar: handleChangeAvatar }))) : (react_1.default.createElement(PersonalForm_1.default, __assign({}, formikProps, { onAddEmpty: onAddEmpty, onChange: onChange, onRemove: onRemove, togglePasswordInputs: togglePasswordInputs, onImageChange: onImageChange, passwordResetCollapsed: passwordResetCollapsed, isLoading: isLoading, handleChangeAvatar: handleChangeAvatar })));
            }))));
};
exports.default = Settings;
